import { gql, useMutation } from "@apollo/client";

import { Asset, UpdateAssetInput } from "../../../generated/gql/graphql";

const UPDATE_ASSET = gql`
  mutation UpdateAsset($updateAssetId: String!, $input: UpdateAssetInput!) {
    updateAsset(id: $updateAssetId, input: $input) {
      id
      approval
      status
      sort
      type
      name
      image
      parentId
      categoryId
      nextAssetId
      prevAssetId
      contentAmount
      contentUnit
      favorite
      geometry
      metashotsType
      languageRegionsId
      assetTypes
      brandId
      collectionId
      oderIndex
      dateCreated
      dateUpdated
      projectId
      masterId
      adaptionId
    }
  }
`;

type AssetApi = {
  updateAsset(id: string, input: UpdateAssetInput): Promise<Asset>;
};

export default function useAsset(): AssetApi {
  const [updateAssetMut] = useMutation<UpdateAssetInput>(UPDATE_ASSET);

  async function updateAsset(
    id: string,
    input: UpdateAssetInput
  ): Promise<Asset> {
    if (!id) {
      throw new Error("Id is required");
    }

    const result = await updateAssetMut({
      variables: {
        updateAssetId: id,
        input,
      },
    });

    if (result.errors && result.errors.length > 0) {
      throw new Error(`Error updating asset: ${result.errors}`);
    }

    return result.data as Asset;
  }

  return {
    updateAsset,
  };
}
